<template>
    <div class="paper">
        <div class="container-fluid">
            <div class="row">
                <div v-if="CheckPermission('FundDevelopment.RaisersEdgeOperations')" class="col">
                    <div class="form-group">
                        <label>Upload Raisers Edge Actions File:</label>
                        <b-form ref="raisersedgeactions" style="margin-top:1rem;" @submit="ImportRaisersEdgeActions">
                            <b-form-group>
                                <b-form-file no-drop
                                             name="FileData"
                                             accept="*.csv"
                                             class="form-control"
                                             required />
                                <button class="form-control" type="submit">UPLOAD</button>
                            </b-form-group>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    // import helper functions

    export default {
        data: function () {
            return {

            };
        },
        methods: {
            ImportRaisersEdgeActions(e) {
                e.preventDefault();
                let form = this.$refs['raisersedgeactions'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("POST", "FundDevelopment/RaisersEdge/ReplaceActions", formData, this.ImportRaisersEdgeActionsSuccess, () => { }, true);
            },
            ImportRaisersEdgeActionsSuccess(response) {
                alert("file uploaded!");
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {

        },
        mounted() {

        },
        computed: {

        },
        watch: {

        },
    }

</script>

<style scoped>
    .paper {
        width: auto !important;
    }
</style>